export default function getModalAdvancedOptionsAttribute(attribute) {
  return state => state.getIn(['modalAdvancedOptions', attribute]);
}
